import React from 'react';
import InvoiceType from 'bz-pronto-core/enum/invoice-type';

class TransferMenuItem extends React.Component {
  render() {
    return !!this.show ? this.props.children : null;
  }

  get show() {
    let { invoice = {} } = this.props;
    let { globalType } = invoice;

    return globalType !== InvoiceType.Pronto;
  }
}

export default TransferMenuItem;
